import styled from "styled-components";

import { COLORS } from "@Utils";

export const Text = styled.p`
  color: ${COLORS.GREY};
  font-size: 0.5em;
  line-height: 1.3em;
  letter-spacing: 0.03em;
  margin: 0px;
`;

export const BigText = styled.p`
  color: ${COLORS.GREY};
  font-size: 0.8em;
  line-height: 1.3em;
  letter-spacing: 0.03em;
  margin: 0px;
`;
